import { useRecoilValue } from "recoil";
import { stepState, userState } from "../../store";

export default function () {
  const { activeUserId } = useRecoilValue(stepState);
  const { id } = useRecoilValue(userState);
  return activeUserId === id;
}
